import { createLucideIcon } from 'lucide-react';
export const QuestionCircle = createLucideIcon('question-circle', [
  [
    'path',
    {
      d: 'M11.5 17C11.5 17 11.5002 17.9529 11.5002 19',
      key: '17wvho',
    },
  ],
  [
    'path',
    {
      d: 'M9 9.85714C9 8.2943 10 7 12 7C14 7 15 8.30833 15 9.85714C15 11 13.9082 11.8041 13 12.1429L12.4922 12.3177C11.5 12.7143 11.5 12.7143 11.5 14.4286V15',
      key: '1f1m9m',
    },
  ],
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
      key: '1mglay',
    },
  ],
]);
